import './list.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content contest-rules-list">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<h1 className="title">{props.intl('List of Config rules')}</h1>
				</div>
			</div>
			<div className="container__content-body">
				<div className="contest-rules-list__create">
					{ props.can('contestEdit') && (
						<Link
							to="contests/create/"
							className="ui-btn ui-btn-primary ui-btn-sign__plus">
							{props.intl('Create new Config rule')}
						</Link>
					) }
				</div>
				<Table {...props} />
			</div>
		</div>
	</Animate>
), 'contestView');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/contests/list.js